import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DuelistsListComponent } from './duelists-list.component';

const routes: Routes = [
	{
		path: '',
		component: DuelistsListComponent,
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class DuelistsListComponentRoutingModule {}
